import Row from '@sdk/components/ui/spacing/Row';
import { Feature } from '@sdk/common/features';
import gettext from '@sdk/lang/gettext';
import { useSession } from '@sdk/session/SessionContext';

import SecureSvg from '@web/assets/svg/Icons/16/secure.svg';
import PremiumGuardLabel from '@web/premiumGuard/PremiumGuardLabel';
import PremiumGuard from '@web/premiumGuard/PremiumGuard';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';
import getPremiumTooltipId from '@web/premiumGuard/getPremiumTooltipId';
import { Group } from '@web/conversations/ConversationsSidebar/components/Group/Group';
import { PathnameEnum } from '@web/Router/router.types';
import { ConversationBasic } from '@web/conversations/types/Conversation';
import { useGroupConversationsPremiumGuard } from '@web/conversations/hooks/useGroupConversationsPremiumGuard';

import { TitleWrapper } from './groupConversationsSection.styles';

type Props = {
  canStartGroupConversation: boolean;
  items: ConversationBasic[];
};

export const GroupConversationsSection = ({ canStartGroupConversation, items }: Props) => {
  const { areGroupConversationsEnabled, premiumGuardConfig, tooltipRefs, tooltipContent } =
    useGroupConversationsPremiumGuard();
  const { currentUser } = useSession();
  const { isToastBilling } = currentUser.org;
  if (!currentUser.isManager && !areGroupConversationsEnabled) {
    return null;
  }

  return (
    <Group
      createPath={
        canStartGroupConversation && areGroupConversationsEnabled
          ? PathnameEnum.CONVERSATION_COMPOSE_GROUP
          : undefined
      }
      isAccessRestricted={!areGroupConversationsEnabled}
      tooltipContent={tooltipContent}
      items={items}
      title={
        <TitleWrapper>
          <PremiumGuard
            hasAccess={areGroupConversationsEnabled}
            premiumFeature={Feature.groupMessages}
            premiumGuardModalName={PremiumModalNames.groupMessages}
            tooltipRef={tooltipRefs[getPremiumTooltipId(Feature.groupMessages)]}>
            <Row justifyContent="space-between" alignItems="center">
              {gettext('Group conversations')}
              {!areGroupConversationsEnabled &&
                (!isToastBilling ? (
                  <PremiumGuardLabel
                    label={premiumGuardConfig.requiredPlan}
                    tooltipId={premiumGuardConfig.tooltipId}
                    tooltipText={tooltipContent}
                    data-place="right"
                  />
                ) : (
                  <SecureSvg />
                ))}
              {}
            </Row>
          </PremiumGuard>
        </TitleWrapper>
      }
    />
  );
};
